export default "__VITE_ASSET__CWRCLRJZ__"